var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#466373"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1852 21L14.3297 18.6211H11.0543L10.2164 21H8.73984L11.9449 12.3984H13.4684L16.6734 21H15.1852ZM13.9605 17.4141L13.1578 15.082C13.0992 14.9258 13.0172 14.6797 12.9117 14.3438C12.8102 14.0078 12.7398 13.7617 12.7008 13.6055C12.5953 14.0859 12.441 14.6113 12.2379 15.1816L11.4645 17.4141H13.9605ZM19.393 21H18.0043V12.4336H22.8383V13.6172H19.393V16.2949H22.6215V17.4844H19.393V21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAf);
export default __webpack_public_path__ + "static/media/icon-af.33290340cedfe61d44c2a07b2c2f956c.svg";
export { ForwardRef as ReactComponent };